/**
 * Limpia el RUT eliminando puntos, guiones y espacios.
 * @param {string} rut
 * @returns {string} Rut limpio
 */
export const cleanRut = (rut) => {
    return rut.replace(/[\.\-]/g, "").trim();
};

/**
 * Calcula el dígito verificador de un RUT dado.
 * @param {string} rut Sin dígito verificador ni puntos o guiones
 * @returns {string} Dígito verificador calculado (0-9 o K)
 */
export const calculateCheckDigit = (rut) => {
    let total = 0;
    let multiplier = 2;

    for (let i = rut.length - 1; i >= 0; i--) {
        total += parseInt(rut[i], 10) * multiplier;
        multiplier = multiplier === 7 ? 2 : multiplier + 1;
    }

    const remainder = total % 11;
    const checkDigit = 11 - remainder;

    if (checkDigit === 11) return "0";
    if (checkDigit === 10) return "K";
    return checkDigit.toString();
};

/**
 * Valida un RUT.
 * @param {string} rut RUT con dígito verificador
 * @returns {boolean} True si el RUT es válido
 */
export const validateRut = (rut) => {
    const cleanedRut = cleanRut(rut);
    if (!/^\d{1,8}[0-9Kk]$/.test(cleanedRut)) return false;

    const body = cleanedRut.slice(0, -1);
    const givenCheckDigit = cleanedRut.slice(-1).toUpperCase();
    const expectedCheckDigit = calculateCheckDigit(body);

    return givenCheckDigit === expectedCheckDigit;
};

/**
 * Formatea un RUT con puntos y guión.
 * @param {string} rut Limpio, sin puntos ni guiones
 * @returns {string} RUT formateado (ejemplo: 12.345.678-9)
 */
export const formatRut = (rut) => {
    const cleanedRut = cleanRut(rut);
    const body = cleanedRut.slice(0, -1);
    const checkDigit = cleanedRut.slice(-1);

    return (
        body
            .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + // Inserta puntos cada 3 dígitos
        "-" +
        checkDigit
    );
};
